export default __webpack_public_path__ + "static/media/2.89265d09.gif";